"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var webAApi_2 = require("../../../../api/webAApi");
var moment = require("moment");
var PlayerBonusesListCtl = /** @class */ (function (_super) {
    __extends(PlayerBonusesListCtl, _super);
    function PlayerBonusesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_bonus_template_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_id; });
        _this.dk_bonus_template_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_title; });
        _this.dk_bonus_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_type_code; });
        _this.dk_bonus_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_type_title; });
        _this.dk_promo_code_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_code_id; });
        _this.dk_promo_code_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_code_title; });
        _this.dk_money_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.money_balance; });
        _this.dk_bonus_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_balance; });
        _this.dk_start_bonus_money_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_bonus_money_balance; });
        _this.dk_start_bonus_bonus_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_bonus_bonus_balance; });
        _this.dk_start_player_money_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_player_money_balance; });
        _this.dk_totalbet_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.totalbet_amount; });
        _this.dk_wagering_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wagering_amount; });
        _this.dk_wager = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wager; });
        _this.dk_bonus_state_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_state_code; });
        _this.dk_bonus_state_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_state_title; });
        _this.dk_is_bonus_has_ttl = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_bonus_has_ttl; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_activated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_activated; });
        _this.dk_date_to_expire = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_to_expire; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_date_cfg_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_cfg_changed; });
        _this.dk_freespins_avail = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespins_avail; });
        _this.dk_freespins_played = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespins_played; });
        _this.dk_is_freespins = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_freespins; });
        _this.dk_after_complete_credits_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.after_complete_credits_count; });
        _this.dk_complete_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.complete_amount; });
        _this.dk_completition_max_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.completition_max_amount; });
        _this.dk_after_completed_credit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.after_completed_credit_amount; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerBonusesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerBonusesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player bonus with id [" + id + "] not found !";
    };
    PlayerBonusesListCtl.prototype.LoadData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListPlayerBonusesByPlayerIdAndDateRangeGet.exec({
            user_player_id: data.playerId,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    bonus_template_id: resp.list[i].bonus_template_id,
                    bonus_template_title: resp.list[i].bonus_template_title,
                    bonus_type_code: resp.list[i].bonus_type_code,
                    bonus_type_title: resp.list[i].bonus_type_title,
                    promo_code_id: resp.list[i].promo_code_id,
                    promo_code_title: resp.list[i].promo_code_title,
                    money_balance: resp.list[i].money_balance,
                    bonus_balance: resp.list[i].bonus_balance,
                    start_bonus_money_balance: resp.list[i].start_bonus_money_balance,
                    start_bonus_bonus_balance: resp.list[i].start_bonus_bonus_balance,
                    start_player_money_balance: resp.list[i].start_player_money_balance,
                    totalbet_amount: resp.list[i].totalbet_amount,
                    wagering_amount: resp.list[i].wagering_amount,
                    wager: resp.list[i].wager,
                    bonus_state_code: resp.list[i].bonus_state_code,
                    bonus_state_title: resp.list[i].bonus_state_title,
                    is_bonus_has_ttl: resp.list[i].is_bonus_has_ttl,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_activated: moment(resp.list[i].date_activated_uts_ms).utc(false),
                    date_to_expire: moment(resp.list[i].date_to_expire_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    date_cfg_changed: moment(resp.list[i].date_cfg_changed_uts_ms).utc(false),
                    freespins_avail: resp.list[i].freespins_avail,
                    freespins_played: resp.list[i].freespins_played,
                    is_freespins: resp.list[i].is_freespins,
                    event_binding_id: resp.list[i].event_binding_id,
                    event_binding_title: resp.list[i].event_binding_title,
                    usr_admin_id: resp.list[i].usr_admin_id,
                    usr_admin_login: resp.list[i].usr_admin_login,
                    after_complete_credits_count: resp.list[i].after_complete_credits_count,
                    complete_amount: resp.list[i].complete_amount,
                    completition_max_amount: resp.list[i].completition_max_amount,
                    after_completed_credit_amount: resp.list[i].after_completed_credit_amount
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerBonusesListCtl.prototype.LoadDataAvail = function (playerId, onDone) {
        var _this = this;
        webAApi_2.ListPlayerAvailableBonusesByPlayerIdGet.exec({
            user_player_id: playerId,
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    bonus_template_id: resp.list[i].bonus_template_id,
                    bonus_template_title: resp.list[i].bonus_template_title,
                    bonus_type_code: resp.list[i].bonus_type_code,
                    bonus_type_title: resp.list[i].bonus_type_title,
                    promo_code_id: resp.list[i].promo_code_id,
                    promo_code_title: resp.list[i].promo_code_title,
                    money_balance: resp.list[i].money_balance,
                    bonus_balance: resp.list[i].bonus_balance,
                    start_bonus_money_balance: resp.list[i].start_bonus_money_balance,
                    start_bonus_bonus_balance: resp.list[i].start_bonus_bonus_balance,
                    start_player_money_balance: resp.list[i].start_player_money_balance,
                    totalbet_amount: resp.list[i].totalbet_amount,
                    wagering_amount: resp.list[i].wagering_amount,
                    wager: resp.list[i].wager,
                    bonus_state_code: resp.list[i].bonus_state_code,
                    bonus_state_title: resp.list[i].bonus_state_title,
                    is_bonus_has_ttl: resp.list[i].is_bonus_has_ttl,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_activated: moment(resp.list[i].date_activated_uts_ms).utc(false),
                    date_to_expire: moment(resp.list[i].date_to_expire_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    date_cfg_changed: moment(resp.list[i].date_cfg_changed_uts_ms).utc(false),
                    freespins_avail: resp.list[i].freespins_avail,
                    freespins_played: resp.list[i].freespins_played,
                    is_freespins: resp.list[i].is_freespins,
                    event_binding_id: resp.list[i].event_binding_id,
                    event_binding_title: resp.list[i].event_binding_title,
                    usr_admin_id: resp.list[i].usr_admin_id,
                    usr_admin_login: resp.list[i].usr_admin_login,
                    after_complete_credits_count: resp.list[i].after_complete_credits_count,
                    complete_amount: resp.list[i].complete_amount,
                    completition_max_amount: resp.list[i].completition_max_amount,
                    after_completed_credit_amount: resp.list[i].after_completed_credit_amount
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerBonusesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPlayerBonus.exec({
            usr_player_id: data.usr_player_id,
            bonus_template_id: data.bonus_template_id,
            amount: data.amount
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                title: resp.bonus_title,
                bonus_template_id: data.bonus_template_id,
                bonus_template_title: resp.bonus_template_title,
                bonus_type_code: resp.bonus_type_code,
                bonus_type_title: resp.bonus_type_title,
                promo_code_id: resp.promo_code_id,
                promo_code_title: resp.promo_code_title,
                money_balance: resp.money_balance,
                start_bonus_money_balance: resp.start_bonus_money_balance,
                start_bonus_bonus_balance: resp.start_bonus_bonus_balance,
                start_player_money_balance: resp.start_player_money_balance,
                bonus_balance: resp.bonus_balance,
                totalbet_amount: resp.totalbet_amount,
                wagering_amount: resp.wagering_amount,
                wager: resp.wager,
                bonus_state_code: resp.bonus_state_code,
                bonus_state_title: resp.bonus_state_title,
                is_bonus_has_ttl: resp.is_bonus_has_ttl,
                description: resp.bonus_description,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_activated: moment(resp.date_added_uts_ms).utc(false),
                date_to_expire: moment(resp.date_to_expire_uts_ms).utc(false),
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                date_cfg_changed: moment(resp.date_added_uts_ms).utc(false),
                freespins_avail: resp.freespins_avail,
                freespins_played: resp.freespins_played,
                is_freespins: resp.is_freespins,
                event_binding_id: resp.event_binding_id,
                event_binding_title: resp.event_binding_title,
                usr_admin_id: resp.usr_admin_id,
                usr_admin_login: resp.usr_admin_login,
                after_complete_credits_count: 0,
                complete_amount: 0,
                completition_max_amount: 0,
                after_completed_credit_amount: 0
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerBonusesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPlayerBonus.exec({
                data: {
                    usr_player_bonus_id: data.key,
                    title: data.title,
                    description: data.description,
                    is_will_expire: data.is_will_expire,
                    expire_to_year: data.expire_to_year,
                    expire_to_month: data.expire_to_month,
                    expire_to_day: data.expire_to_day,
                    expire_to_hour: data.expire_to_hour,
                    expire_to_minute: data.expire_to_minute,
                    expire_to_second: data.expire_to_second
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.description = data.description;
                _tmp.is_bonus_has_ttl = data.is_will_expire;
                _tmp.date_to_expire = moment(resp.date_to_expire_uts_ms).utc(false);
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerBonusesListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PlayerBonusesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePlayerBonus.exec({
                data: {
                    usr_player_bonus_id: key
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerBonusesListCtl.prototype.DoSetStatusActivated = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPlayerBonusStatusActivated.exec({
                data: {
                    usr_player_bonus_id: key
                }
            }, function (resp) {
                _tmp.bonus_state_code = resp.bonus_state_code;
                _tmp.bonus_state_title = resp.bonus_state_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerBonusesListCtl.prototype.DoSetStatusCompleted = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPlayerBonusStatusCompleted.exec({
                data: {
                    usr_player_bonus_id: key
                }
            }, function (resp) {
                _tmp.bonus_state_code = resp.bonus_state_code;
                _tmp.bonus_state_title = resp.bonus_state_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerBonusesListCtl.prototype.DoSetStatusCancelled = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPlayerBonusStatusCancelled.exec({
                data: {
                    usr_player_bonus_id: key
                }
            }, function (resp) {
                _tmp.bonus_state_code = resp.bonus_state_code;
                _tmp.bonus_state_title = resp.bonus_state_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerBonusesListCtl.prototype.DoSetStatusCancelledToActive = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPlayerBonusFromCancelledToActive.exec({
                data: {
                    usr_player_bonus_id: key
                }
            }, function (resp) {
                _tmp.bonus_state_code = resp.bonus_state_code;
                _tmp.bonus_state_title = resp.bonus_state_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerBonusesListCtl.prototype.DoDepositBonusAmount = function (key, amount, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDepositPlayerBonusAmtByPlayerBonusId.exec({
                data: {
                    usr_player_bonus_id: key,
                    amount_to_deposit: amount
                }
            }, function (resp) {
                _tmp.money_balance = resp.money_balance;
                _tmp.bonus_balance = resp.bonus_balance;
                _tmp.totalbet_amount = resp.totalbet_amount;
                _tmp.wagering_amount = resp.wagering_amount;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerBonusesListCtl.prototype.DoDepositTotalBetAmount = function (key, amount, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDepositPlayerTotalBetAmtByPlayerBonusId.exec({
                data: {
                    usr_player_bonus_id: key,
                    amount_to_deposit: amount
                }
            }, function (resp) {
                _tmp.money_balance = resp.money_balance;
                _tmp.bonus_balance = resp.bonus_balance;
                _tmp.totalbet_amount = resp.totalbet_amount;
                _tmp.wagering_amount = resp.wagering_amount;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    /*  public DoDepositMoneyAmountFromPlayersBalance(key: number, amount: number, onDone?: () => void) {
          let _tmp = this.getById(key);
          if (_tmp) {
              DoDepositPlayerMoneyAmtFromPlayersBalance.exec({
                  data: {
                      usr_player_bonus_id: key,
                      amount_to_deposit: amount
                  }
              }, (resp) => {
                  _tmp.money_balance = resp.money_balance;
                  _tmp.bonus_balance = resp.bonus_balance;
                  _tmp.totalbet_amount = resp.totalbet_amount;
                  _tmp.wagering_amount = resp.wagering_amount;
                  this.Update();
                  if (onDone) {
                      onDone();
                  }
              }, (err) => {
                  this._errDialog.ShowApiError(err);
              });
          }
      } */
    PlayerBonusesListCtl.prototype.DoWithdrawBonusAmount = function (key, amount, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoWithdrawPlayerBonusAmtByPlayerBonusId.exec({
                data: {
                    usr_player_bonus_id: key,
                    amount_to_withdraw: amount
                }
            }, function (resp) {
                _tmp.money_balance = resp.money_balance;
                _tmp.bonus_balance = resp.bonus_balance;
                _tmp.totalbet_amount = resp.totalbet_amount;
                _tmp.wagering_amount = resp.wagering_amount;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerBonusesListCtl.prototype.DoWithdrawTotalBetAmount = function (key, amount, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoWithdrawPlayerTotalBetAmtByPlayerBonusId.exec({
                data: {
                    usr_player_bonus_id: key,
                    amount_to_withdraw: amount
                }
            }, function (resp) {
                _tmp.money_balance = resp.money_balance;
                _tmp.bonus_balance = resp.bonus_balance;
                _tmp.totalbet_amount = resp.totalbet_amount;
                _tmp.wagering_amount = resp.wagering_amount;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PlayerBonusesListCtl;
}(BaseController_1.BaseController));
exports.PlayerBonusesListCtl = PlayerBonusesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ctl/PlayerBonusesListCtl.ts
// module id = 971
// module chunks = 0